import moment from 'moment';
import { t } from 'ttag';

export const ROLE_ACCESS = [
    {
        name: 'can_view_document',
        defaultValue: false,
        label: t`Перегляд всіх документів компанії`,
    },
    {
        name: 'can_comment_document',
        defaultValue: true,
        label: t`Коментування документів`,
    },
    {
        name: 'can_upload_document',
        defaultValue: true,
        label: t`Завантаження документів у сервіс`,
    },
    {
        name: 'can_download_document',
        defaultValue: true,
        label: t`Вивантаження документів на локальний комп’ютер`,
    },
    {
        name: 'can_print_document',
        defaultValue: true,
        label: t`Друк документів`,
    },
    {
        name: 'can_delete_document',
        defaultValue: true,
        label: t`Видалення документів`,
    },
    {
        name: 'can_sign_and_reject_document',
        defaultValue: true,
        label: t`Підписання та відхилення документів`,
    },
    {
        name: 'can_invite_coworkers',
        defaultValue: true,
        label: t`Запрошення співробітників`,
    },
    {
        name: 'can_edit_company',
        defaultValue: false,
        label: t`Редагування інформації про компанію`,
    },
    {
        name: 'can_edit_roles',
        defaultValue: false,
        label: t`Редагування та видалення співробітників`,
    },
    {
        name: 'can_edit_document_automation',
        defaultValue: true,
        label: t`Налаштування сценаріїв документів`,
    },
    {
        name: 'can_edit_document_fields',
        defaultValue: true,
        label: t`Налаштування додаткових параметрів документів`,
    },
    {
        name: 'can_edit_templates',
        defaultValue: true,
        label: t`Створення та редагування шаблонів`,
    },
    {
        name: 'can_archive_documents',
        defaultValue: false,
        label: t`Переміщення документів у архів`,
    },
    {
        name: 'can_delete_archived_documents',
        defaultValue: false,
        label: t`Видалення архівних документів`,
    },
    {
        name: 'can_create_tags',
        defaultValue: true,
        label: t`Створення нових ярликів`,
    },
] as const;

export const getCurrentTime = () => moment().format('DD.MM.YYYY HH:mm');
